import { rangePresets } from '@gogame/intl-ts';
import { array, string } from '@gogame/schemas';

import { PERIOD_PRESETS } from './presets';

export const periodSchema = array(string())
  .default(rangePresets.LAST_7_DAYS.value)
  .constants(PERIOD_PRESETS)
  .required('Period');
